import styled from "styled-components";
import { media } from "../../theme/theme";
import { StepWrapper } from "./MarketingSteps.styles";

export const Step2Wrapper = styled(StepWrapper)`
    > div {
        &:nth-child(2) {
            order: 0;

            ${media.tablet} {
                order: initial;
            }
        }

        &:nth-child(1) {
            order: 1;

            ${media.tablet} {
                order: initial;
            }
        }
    }
`

export const Step2PartnerWrapper = styled(StepWrapper)`
    > div {
        &:nth-child(2) {
            order: 0;
        }

        &:nth-child(1) {
            order: 1;
        }
    }
`